import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function ShareholderNav() {
    const {locale} = useRouter();

    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.shareholder-relations.title'),
                        href: '/quan-he-co-dong',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default ShareholderNav;
